export const MessageTypes = {
    // Base networking: 0 - 19
    "server_connect": 0, // Not implemented
    "client_connect": 1, // Not implemented
    "client_message": 2, // Not implemented
    "server_message": 3, // Not implemented

    // Game logic: 20 - ?
    "Picture": 20,          //String
    "MoveSticker" : 21,       //Vector2: x for horizontal, y for vertical
    "RotateSticker" : 22,     //bool: true = right, false = left
    "ScaleSticker" : 23,      //bool: true = upscale, false = downscale
    "ValidateSticker": 24,           //bool: true = stick sticker to the wall, false = delete sticker// STRING
    "RandomValuesSticker": 25
}